module.exports = __webpack_public_path__ + "static/media/lens2.7f6c1359.png";